/**
 * Created by chachora on 12/12/18.
 */

import React, { PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import memoizeOne from 'memoize-one';
import ListItemIcon from '@mui/material/ListItemIcon';
import ConnectingAirports from '@mui/icons-material/ConnectingAirports';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { withTranslation } from 'react-i18next';

class AirportsFilter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownOpen: false,
    };
  }

  handleDropdownToggle = () => {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen,
    });
  };

  handleCheckboxChange = (e, checked) => {
    const { onFilterChange } = this.props;
    if (onFilterChange) onFilterChange(e.target.value, checked);
  };

  handleListItemClick = airport => {
    const { onFilterChange } = this.props;
    if (onFilterChange) onFilterChange(airport.name, !airport.selected);
  };

  handleClear = () => {
    this.props.onFilterClear?.();
  };

  getSelectedAirportsCount = memoizeOne(
    airports => airports.filter(airport => airport.selected).length
  );

  render() {
    const { classes, airports, t } = this.props;
    return (
      <>
        <ListItemButton onClick={this.handleDropdownToggle}>
          <ListItemIcon>
            <ConnectingAirports />
          </ListItemIcon>
          <ListItemText>{t('Airports')}</ListItemText>
          {this.state.isDropdownOpen ? (
            <ExpandLess className={classes.expandIcon} />
          ) : (
            <ExpandMore className={classes.expandIcon} />
          )}
        </ListItemButton>
        <Collapse in={this.state.isDropdownOpen}>
          <List dense>
            {airports.map(f => (
              <ListItemButton
                className={classes.item}
                key={f.name}
                onClick={this.handleListItemClick.bind(this, f)}
              >
                <Checkbox
                  className={classes.checkbox}
                  checked={f.selected}
                  style={{ color: f.color }}
                  onChange={this.handleCheckboxChange}
                  value={f.name}
                  disableRipple
                />
                <ListItemText>{f.name}</ListItemText>
              </ListItemButton>
            ))}
          </List>
          {!!this.getSelectedAirportsCount(airports) && (
            <Button
              className={classes.clearButton}
              onClick={this.handleClear}
              size="small"
            >
              <Typography className={classes.clearText} variant="caption">
                Clear
              </Typography>
            </Button>
          )}
        </Collapse>
      </>
    );
  }
}

const styles = theme => ({
  checkbox: {
    padding: '0',
  },
  item: {
    paddingTop: '3px',
    paddingBottom: '3px',
  },
  clearButton: {
    margin: theme.spacing(1),
    marginTop: 0,
  },
});

export default withTranslation()(withStyles(styles)(AirportsFilter));
